import React, { useState } from "react";
import { Link } from "react-router-dom";

/* ============================================================
   PORTFOLIO DATA CONFIGURATION
============================================================ */
const PORTFOLIO_ITEMS = [
 
  {
    id: "ebay-1",
    account_name : 'account1',
    platform: "eBay",
    category: "ebay",
    title: "UK Active Seller Account",
    metrics: { revenue: "£5,428.67", timeline: "90 Days", status: "Active" },
    description: "Fully active UK-based eBay seller account with 264 active listings, handling steady daily volume across auction and fixed-price items.",
    image: "https://ik.imagekit.io/g9mnvfpan/blurr1.png",
    highlights: ["100% positive feedback rating (462 score)", "£5,428.67 revenue across 564 orders (90d)", "25,834 listing views with +38.9% growth"],
  },
  {
    id: "ebay-2",
    account_name : 'account2',
    platform: "eBay",
    category: "ebay",
    title: "High Volume Enterprise Store",
    metrics: { revenue: "£32,845.60", timeline: "90 Days", status: "Active & Scaling" },
    description: "High-revenue UK store running nearly 300 active listings with high visibility, consistent day-to-day conversion, and strong sales momentum.",
    image: "https://ik.imagekit.io/g9mnvfpan/blurr2.png",
    highlights: ["£32,845.60 90-day sales (+45.7% growth)", "98,742 total listing views", "287 active listings with 468 total orders"],
  },
  {
    id: "ebay-3",
    account_name : 'account3',
    platform: "eBay",
    category: "ebay",
    title: "Top-Rated UK Store",
    metrics: { revenue: "£6,482.75", timeline: "90 Days", status: "Active" },
    description: "Multi-listing portfolio account with optimized Buy It Now listings, active buyer offers, and managed order processing setup.",
    image: "https://ik.imagekit.io/g9mnvfpan/blurr3.png",
    highlights: ["100% positive feedback rating (268 score)", "£6,482.75 90-day revenue (+48.9% growth)", "218 active listings & 36,782 views"],
  },
  {
    id: "ebay-4",
    account_name : 'account4',
    platform: "eBay",
    category: "ebay",
    title: "Established High-Order Volume Account",
    metrics: { revenue: "£8,925.64", timeline: "90 Days", status: "Active" },
    description: "Established seller hub account driving consistent monthly order volume with optimized promotional offers and low return rates.",
    image: "https://ik.imagekit.io/g9mnvfpan/blurr4.png",
    highlights: ["642 total orders processed (90d)", "£8,925.64 revenue with +37.2% growth", "100% positive feedback rating (326 score)"],
  },
];

const CATEGORIES = [
  { label: "All Stores", value: "all" },
  { label: "TikTok Shop", value: "tiktok-shop" },
  { label: "eBay", value: "ebay" },
  { label: "Shopify", value: "shopify" },
];

/* ============================================================
   PORTFOLIO PAGE COMPONENT
============================================================ */
export default function PortfolioPage() {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedItem, setSelectedItem] = useState(null);

  const filteredItems = activeTab === "all"
    ? PORTFOLIO_ITEMS
    : PORTFOLIO_ITEMS.filter((item) => item.category === activeTab);

  return (
    <div style={styles.pageWrapper}>
      {/* Hero Header */}
      <section style={styles.heroSection}>
        <span style={styles.badge}>Track Record & Case Studies</span>
        <h1 style={styles.heading}>E-Commerce Account Portfolio</h1>
        <p style={styles.subheading}>
          Explore real account setups, store optimizations, and revenue milestones achieved across eBay, TikTok Shop, and Shopify platforms.
        </p>

        {/* Filter Tabs */}

      </section>

      {/* Grid Display */}
      <section style={styles.gridSection}>
        <div style={styles.grid}>
          {filteredItems.map((item) => (
            <div key={item.id} style={styles.card} className="portfolio-card">
              <div style={styles.imageWrapper}>
                <img src={item.image} alt={item.title} style={styles.cardImage} />
                <span style={styles.platformBadge}>{item.platform}</span>
              </div>

              <div style={styles.cardContent}>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                <p style={styles.cardDesc}>{item.description}</p>

                {/* Key Metrics Pill Grid */}
                <div style={styles.metricsRow}>
                  <div style={styles.metricPill}>
                    <span style={styles.metricLabel}>Revenue</span>
                    <strong style={styles.metricValue}>{item.metrics.revenue}</strong>
                  </div>
                  <div style={styles.metricPill}>
                    <span style={styles.metricLabel}>Timeframe</span>
                    <strong style={styles.metricValue}>{item.metrics.timeline}</strong>
                  </div>
                  <div style={styles.metricPill}>
                    <span style={styles.metricLabel}>Status</span>
                    <strong style={{ ...styles.metricValue, color: "#10b981" }}>{item.metrics.status}</strong>
                  </div>
                </div>

                <button  style={styles.viewDetailsBtn}>
                <Link to={`/portfolio/${item.account_name}`}>
                  View Screenshots & Insights →
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Bottom Banner */}
      <section style={styles.ctaSection}>
        <h2>Ready to build or scale your store?</h2>
        <p>Let our team handle your account setup, verification, listing, and scaling strategy.</p>
        <Link to="/contact" style={styles.ctaButton}>Get Started Today</Link>
      </section>

      {/* Modal Lightbox for Detailed View */}
      {selectedItem && (
        <div style={styles.modalBackdrop} onClick={() => setSelectedItem(null)}>
          <div style={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={() => setSelectedItem(null)}>✕</button>
            <span style={styles.platformBadgeModal}>{selectedItem.platform}</span>
            <h2 style={{ color: "#fff", marginTop: "12px", marginBottom: "8px" }}>{selectedItem.title}</h2>
            <p style={{ color: "rgba(255,255,255,0.7)", marginBottom: "20px" }}>{selectedItem.description}</p>

            <img
              src={selectedItem.image}
              alt={selectedItem.title}
              style={{ width: "100%", borderRadius: "12px", marginBottom: "20px", border: "1px solid rgba(255,255,255,0.1)" }}
            />

            <h4 style={{ color: "#fd8110", marginBottom: "10px" }}>Key Execution Highlights</h4>
            <ul style={{ color: "rgba(255,255,255,0.85)", paddingLeft: "20px", lineHeight: "1.8" }}>
              {selectedItem.highlights.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

/* ============================================================
   STYLES OBJECT
============================================================ */
const styles = {
  pageWrapper: {
    minHeight: "100vh",
    backgroundColor: "#06060a",
    color: "#ffffff",
    fontFamily: "'Outfit', sans-serif",
    paddingTop: "100px",
    paddingBottom: "60px",
  },
  heroSection: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 24px",
    textAlign: "center",
  },
  badge: {
    color: "#fd8110",
    fontSize: "12px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.15em",
  },
  heading: {
    fontSize: "clamp(2.2rem, 4vw, 3.5rem)",
    fontWeight: "800",
    margin: "12px 0 16px",
    letterSpacing: "-0.02em",
  },
  subheading: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "1.1rem",
    maxWidth: "680px",
    margin: "0 auto 36px",
    lineHeight: "1.6",
  },
  filterContainer: {
    display: "inline-flex",
    gap: "8px",
    background: "rgba(255, 255, 255, 0.05)",
    padding: "6px",
    borderRadius: "9999px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  filterBtn: {
    padding: "10px 22px",
    borderRadius: "9999px",
    background: "transparent",
    color: "rgba(255, 255, 255, 0.65)",
    border: "none",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 200ms ease",
  },
  filterBtnActive: {
    background: "#ffffff",
    color: "#000000",
    fontWeight: "600",
  },
  gridSection: {
    maxWidth: "1200px",
    margin: "50px auto 0",
    padding: "0 24px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: "28px",
  },
  card: {
    background: "rgba(16, 16, 24, 0.75)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "20px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(12px)",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "210px",
    overflow: "hidden",
  },
  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  platformBadge: {
    position: "absolute",
    top: "12px",
    left: "12px",
    background: "rgba(0, 0, 0, 0.75)",
    color: "#ffffff",
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "600",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
  },
  cardContent: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "8px",
    lineHeight: "1.3",
  },
  cardDesc: {
    color: "rgba(255, 255, 255, 0.65)",
    fontSize: "13.5px",
    lineHeight: "1.5",
    marginBottom: "20px",
  },
  metricsRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "8px",
    marginBottom: "20px",
  },
  metricPill: {
    background: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.06)",
    borderRadius: "10px",
    padding: "8px",
    textAlign: "center",
  },
  metricLabel: {
    display: "block",
    fontSize: "10px",
    color: "rgba(255, 255, 255, 0.45)",
    textTransform: "uppercase",
  },
  metricValue: {
    display: "block",
    fontSize: "12px",
    fontWeight: "700",
    color: "#ffffff",
    marginTop: "2px",
  },
  viewDetailsBtn: {
    marginTop: "auto",
    padding: "12px",
    background: "rgba(253, 129, 16, 0.12)",
    color: "#fd8110",
    border: "1px solid rgba(253, 129, 16, 0.3)",
    borderRadius: "12px",
    fontWeight: "600",
    fontSize: "13.5px",
    cursor: "pointer",
    transition: "background 200ms ease",
  },
  ctaSection: {
    maxWidth: "1000px",
    margin: "80px auto 0",
    padding: "40px 20px",
    textAlign: "center",
    background: "radial-gradient(circle at center, rgba(253, 129, 16, 0.12) 0%, rgba(6, 6, 10, 0) 70%)",
    borderTop: "1px solid rgba(255,255,255,0.08)",
  },
  ctaButton: {
    display: "inline-block",
    marginTop: "20px",
    padding: "14px 32px",
    background: "#ffffff",
    color: "#000000",
    fontWeight: "700",
    borderRadius: "9999px",
    textDecoration: "none",
  },
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.85)",
    backdropFilter: "blur(12px)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  modalCard: {
    background: "#0e0e16",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "20px",
    maxWidth: "600px",
    width: "100%",
    padding: "32px",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: "16px",
    right: "16px",
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: "18px",
    cursor: "pointer",
  },
  platformBadgeModal: {
    background: "#fd8110",
    color: "#000",
    padding: "4px 10px",
    borderRadius: "9999px",
    fontSize: "11px",
    fontWeight: "700",
  },
};